import axios, { AxiosPromise } from 'axios';
import { ILog } from '../../../@types/model/logs/Log';

export default class LogHttpService {
    public static getErrorLogs(fromDateUnix ?: number, toDateUnix ?: number) : AxiosPromise<Array<ILog>> {
        return axios.get(`${API_URL}/v1/Log/GetLogs`, {
            params: {
                fromDateUnix,
                toDateUnix,
            },
        });
    }
}
